import { AlertCircle, Settings } from "lucide-react";
import Seo, { buildBreadcrumbLd } from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import PageHero from "../components/PageHero";
import { company } from "../data/site";

const crumbs = [
  { label: "Startseite", to: "/" },
  { label: "Datenschutz", to: "/datenschutz" },
];

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-heading text-2xl font-bold text-anthracite">{title}</h2>
    <div className="mt-4 space-y-3 text-base leading-relaxed text-mid-gray">{children}</div>
  </div>
);

export default function Datenschutz() {
  return (
    <div data-testid="page-datenschutz">
      <Seo path="/datenschutz" title="Datenschutzerklärung | Rümpeltaxi" description="Datenschutzerklärung von Rümpeltaxi." noindex jsonLd={buildBreadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <PageHero kicker="Rechtliches" title="Datenschutzerklärung" lead="Informationen zur Verarbeitung personenbezogener Daten. Die finalen, rechtlich geprüften Texte werden vor der Veröffentlichung ergänzt." />
      <section className="bg-white py-16 md:py-24">
        <div className="container-page max-w-3xl">
          <div className="mb-8 flex items-start gap-3 rounded-sm border border-yellow/40 bg-yellow/10 p-5">
            <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-yellow-dark" />
            <p className="text-sm text-anthracite">
              Diese Datenschutzerklärung enthält Platzhalter und stellt keine Rechtsberatung dar.
              Vor der Veröffentlichung ist eine vollständige, rechtssichere Fassung erforderlich.
            </p>
          </div>

          <Section title="1. Verantwortlicher">
            <p>Thomas Dietrich – Rümpeltaxi, {company.street}, {company.postal} {company.city}, {company.country}. Kontakt: {company.email}, {company.phoneDisplay}.</p>
          </Section>

          <Section title="2. Verarbeitung bei Kontaktanfragen">
            <p>
              Wenn Sie uns über das Anfrageformular, das Geschäftskundenformular, per E-Mail, Telefon
              oder WhatsApp kontaktieren, verarbeiten wir die von Ihnen übermittelten Angaben (z. B.
              Name, Kontaktdaten, Objektadresse, Beschreibung des Anliegens sowie ggf. hochgeladene
              Bilder und PDF-Dateien) ausschließlich zur Bearbeitung Ihrer Anfrage und zur
              Angebotserstellung. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und lit. f DSGVO.
            </p>
          </Section>

          <Section title="3. Anfrageverwaltung und Speicherung">
            <p>
              Eingehende Anfragen werden in einer Datenbank gespeichert und in einem geschützten,
              nicht öffentlichen Administrationsbereich verwaltet (Status, interne Notizen, Termine).
              Hochgeladene Dateien werden geschützt gespeichert und sind nur berechtigten Personen
              zugänglich. Anfragen werden gelöscht oder anonymisiert, sobald sie für die Bearbeitung
              nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>
          </Section>

          <Section title="4. Cookies und Einwilligung">
            <p>
              Es werden nur technisch notwendige Cookies ohne Einwilligung gesetzt. Optionale
              Dienste (Statistik, externe Medien) werden ausschließlich nach Ihrer Einwilligung
              geladen. Ihre Einwilligung können Sie jederzeit widerrufen.
            </p>
          </Section>

          <Section title="5. Ihre Rechte">
            <p>
              Ihnen stehen die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung,
              Datenübertragbarkeit und Widerspruch zu. Zudem besteht ein Beschwerderecht bei einer
              Aufsichtsbehörde. [Kontaktweg für Betroffenenrechte ergänzen]
            </p>
          </Section>

          <div className="mt-12">
            <button
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              className="inline-flex items-center gap-2 rounded-sm border border-anthracite px-5 py-3 font-heading text-sm font-bold text-anthracite transition-colors hover:bg-light-gray"
              data-testid="datenschutz-cookie-settings"
            >
              <Settings className="h-4 w-4" /> Cookie-Einstellungen öffnen
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
